module.exports = __webpack_public_path__ + "static/y4420_1-5bfd9d8771c55814c8dd8c102218fada.jpg";